export function booleanToSimNao(val: boolean | null | undefined) {
  if (val === null || val === undefined) return "";
  return val ? "Sim" : "Não";
}
